/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_External_Booking_Edit_Invoices_HeadingInputs */

const en_admin_external_booking_edit_invoices_heading = /** @type {(inputs: Admin_External_Booking_Edit_Invoices_HeadingInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`Invoice`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`Invoices (${i?.count})`);
	return /** @type {LocalizedString} */ ("admin.external_booking_edit.invoices_heading");
};

const de_admin_external_booking_edit_invoices_heading = /** @type {(inputs: Admin_External_Booking_Edit_Invoices_HeadingInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`Rechnung`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`Rechnungen (${i?.count})`);
	return /** @type {LocalizedString} */ ("admin.external_booking_edit.invoices_heading");
};

const es_admin_external_booking_edit_invoices_heading = /** @type {(inputs: Admin_External_Booking_Edit_Invoices_HeadingInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`Factura`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`Facturas (${i?.count})`);
	return /** @type {LocalizedString} */ ("admin.external_booking_edit.invoices_heading");
};

const fr_admin_external_booking_edit_invoices_heading = /** @type {(inputs: Admin_External_Booking_Edit_Invoices_HeadingInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`Facture`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`Factures (${i?.count})`);
	return /** @type {LocalizedString} */ ("admin.external_booking_edit.invoices_heading");
};

const nl_admin_external_booking_edit_invoices_heading = /** @type {(inputs: Admin_External_Booking_Edit_Invoices_HeadingInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`Factuur`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`Facturen (${i?.count})`);
	return /** @type {LocalizedString} */ ("admin.external_booking_edit.invoices_heading");
};

/** @type {(inputs: Admin_External_Booking_Edit_Invoices_HeadingInputs) => LocalizedString} */
const it_admin_external_booking_edit_invoices_heading = en_admin_external_booking_edit_invoices_heading;

/** @type {(inputs: Admin_External_Booking_Edit_Invoices_HeadingInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_invoices_heading = en_admin_external_booking_edit_invoices_heading;

/** @type {(inputs: Admin_External_Booking_Edit_Invoices_HeadingInputs) => LocalizedString} */
const pl_admin_external_booking_edit_invoices_heading = en_admin_external_booking_edit_invoices_heading;

/** @type {(inputs: Admin_External_Booking_Edit_Invoices_HeadingInputs) => LocalizedString} */
const hu_admin_external_booking_edit_invoices_heading = en_admin_external_booking_edit_invoices_heading;

/** @type {(inputs: Admin_External_Booking_Edit_Invoices_HeadingInputs) => LocalizedString} */
const ro_admin_external_booking_edit_invoices_heading = en_admin_external_booking_edit_invoices_heading;

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Invoice" |
* | "other" | "Invoices ({count})" |
*
* @param {Admin_External_Booking_Edit_Invoices_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_invoices_heading = /** @type {((inputs: Admin_External_Booking_Edit_Invoices_HeadingInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Invoices_HeadingInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_invoices_heading(inputs)
	if (locale === "de") return de_admin_external_booking_edit_invoices_heading(inputs)
	if (locale === "es") return es_admin_external_booking_edit_invoices_heading(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_invoices_heading(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_invoices_heading(inputs)
	if (locale === "it") return it_admin_external_booking_edit_invoices_heading(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_invoices_heading(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_invoices_heading(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_invoices_heading(inputs)
	return ro_admin_external_booking_edit_invoices_heading(inputs)
});
export { admin_external_booking_edit_invoices_heading as "admin.external_booking_edit.invoices_heading" }